import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../_Services/user.service';

@Component({
    selector: 'mt-offer-card',
    templateUrl: './offer-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OfferCardComponent implements OnInit, OnChanges {
  @Input() isMobile: boolean;
  @Input() class: string = '';
  @Input() value: any = {};
  @Input() attributes: any = [];
  @Input() acceptButtonFlag: boolean = false
  @Input() applyButtonFlag: boolean = true;
  @Input() acceptOfferButtonFlag: boolean = false;
  @Input() selected: boolean = false;
  @Input() editButton: boolean = false;
  @Input() wideCard: boolean = false;
  @Output() onAction = new EventEmitter<any>();
  @Input() isOfferCompare;
  offerApplied: boolean = false
  disableBoxes = false;
  offerData = [];
  showModal: boolean;
  offerId: number;
  buttons: any = [{ label: 'No', class: 'nobg success' }, { label: 'Yes', class: 'warning', submit: true }];
  selection = new SelectionModel<any>(true, []);
  constructor(
    private router: Router,
    private userService: UserService

  ) { }

  ngOnInit(): void {
    this.initializeCard();

  }
  ngOnChanges() {
    if (this.value && this.value.OfferDetails && this.value.OfferDetails.length > 0) {
      this.value.createdAt = this.value.OfferDetails[0].createdAt;
      this.value.updatedAt = this.value.OfferDetails[0].updatedAt;
      this.value.expiryDate = this.value.OfferDetails[0].expiryDate;
    }
  }



  // to get number of columns
  getColumns(attr: any) {
    // console.log(attr);
    if (attr.body) return Math.round(attr.body.length / 3) + 1;
    return 1;
  }
  initializeCard() {
    if (this.value.fieldJSON1.waiverType === 2) {
      this.value.maxDiscount = this.value.fieldJSON1.maxMarkup;
    }
  }
  onCardClick() {
    this.onAction.emit(this.value);
  }

  getClass(val: any) {
    // console.log('val',val)
    const { type, fieldJSON1 } = val;
    let paymentPlanTitle = fieldJSON1 && fieldJSON1.paymentPlanValue;
    switch (type) {
      case 1:
        return { cardClass: 'success', fontClass: 'offer-tag text-success', title: paymentPlanTitle || 'QuickPay' };
      case 2:
        return { cardClass: 'primary', fontClass: 'offer-tag text-primary', title: paymentPlanTitle || 'Balloon' };
      case 3:
        return { cardClass: 'primary', fontClass: 'offer-tag text-primary', title: paymentPlanTitle || 'Step' };
      case 4:
        return { cardClass: 'warning', fontClass: 'offer-tag text-warning', title: paymentPlanTitle || 'Constant' };
      default:
        return { cardClass: 'primary', fontClass: 'offer-tag text-primary' };
    }
  }
  switchPipeValue(value: any) {
    const { isInPercent } = value;
    if (isInPercent === 0) return 'currency';
    if (isInPercent === 1) return 'percentage';
  }

  onEditOfferClick(id: any) {
    this.offerId = id;
    localStorage.setItem('offerObj', JSON.stringify({ offer: this.value }));
    this.router.navigate([`offers/edit/${this.offerId}`]);
  }

  editData(value) {
    this.onAction.emit(value)
  }

  // to open detactivate modal
  onDeactivateClick(id: any) {
    this.offerId = id;
    this.showModal = true;
  }

  onModalAction($event: boolean) {
    if ($event) {
      this.deactivateOffer();
      return;
    }
    this.showModal = false;
  }
  deactivateOffer() {
    const endpoint = `/api/offers/deactiveOffer/${this.offerId}`;
    this.userService.getApiCall(endpoint).subscribe(res => {
      const { resultLong, resultShort } = res;
      this.userService.notify(resultLong, resultShort);
      if (resultShort === 'success') {
        this.onAction.emit({ [resultShort]: true });
        this.showModal = false;
      }
    });
  }

  applyOffer(selectedOffer: any) {
    console.log("ApplyOffer", selectedOffer)
    this.onAction.emit(selectedOffer);
  }

  acceptOffer(selectedOffer: any) {
    this.onAction.emit(selectedOffer);
  }


  // to handle if the image not loaded or getting error while loading 
  errorHandler(event) {
    event.target.src = "../../../../assets/img/settle-img/offers/gitft-box.png";
  }
}
